import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import {CopilotInstructions} from "../Interfaces/CopilotInstructions";
import {CopilotResult} from "../Interfaces/CopilotResult";
import {CopilotImageResult} from "../Interfaces/CopilotImageResult";
import axios, {CancelTokenSource} from "axios";

const generateMessage = async (payload: CopilotInstructions): Promise<CopilotResult | null> => {
    return new Promise<CopilotResult | null>((resolve, reject) => {
        return AxiosConfig.instance.post(`/copilot/message`, payload).then(res => {
            return resolve(res.data);
        }).catch(error => {
            console.error(error);
            return resolve(null)
        });
    });
}

const getImagesSuggestions = async (payload: {
    message: string,
    keywords: string,
    creativeCommonOnly: boolean,
    language: string,
}, getCancelToken?: (token: CancelTokenSource) => void): Promise<{
    images: Array<CopilotImageResult>,
    keywords: string,
}> => {
    const cancelToken = axios.CancelToken.source();
    if (getCancelToken) getCancelToken(cancelToken);
    return new Promise<{ images: Array<CopilotImageResult>, keywords: string, }>((resolve) => {
        return AxiosConfig.instance.post(`/copilot/images`, payload, {cancelToken: cancelToken.token}).then(res => {
            return resolve(res.data);
        }).catch(error => {
            console.error(error);
            return resolve({
                images: [],
                keywords: "",
            })
        });
    });
}

const uploadImageSuggestion = async (payload: { url: string }): Promise<void> => {
    return new Promise<void>((resolve) => {
        return AxiosConfig.instance.post(`/copilot/image/use`, payload).then(res => {
            return resolve();
        }).catch(error => {
            console.error(error);
            return resolve()
        });
    });
}

export const CopilotApi = {
    generateMessage,
    getImagesSuggestions,
    uploadImageSuggestion
}